import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@mono/ui-components';
import { toast } from 'sonner';
import { COMPANY_ROLE_TYPE_OPTIONS } from '../_shared/constants/companyRoleTypes';
import { useCompanyProfiles, useOwnCompanyProfile } from './referenceDataHooks';
export function ProgramCompanyFields({ companyRoleType, primeContractorCompanyId, onCompanyRoleTypeChange, onPrimeContractorCompanyIdChange, canEdit = true }) {
    const companies = useCompanyProfiles();
    const ownCompany = useOwnCompanyProfile({
        enabled: canEdit
    });
    const handleRoleChange = (value)=>{
        onCompanyRoleTypeChange(value);
        // Declaring "we are the prime" makes the prime org ours — fill it when
        // blank, never overwrite an explicit choice, no-op when unresolvable.
        if (value === 'PRIME' && !primeContractorCompanyId && ownCompany.data?.id) {
            onPrimeContractorCompanyIdChange(ownCompany.data.id);
            // The user touched Role, not Prime — announce the second-field change
            // (sonner's toaster is a polite live region, so SR users hear it too).
            // Synchronous on purpose: this only mutates local form state, unlike
            // the briefing panel, which persists and therefore toasts post-save —
            // hence "prefilled", not "set": nothing is saved until the dialog
            // submits, and cancelling discards it.
            toast.info(`Prime contractor prefilled with ${ownCompany.data.name}`);
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "grid gap-4 sm:grid-cols-2",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "space-y-1.5",
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        htmlFor: "companyRoleType",
                        children: "Company role"
                    }),
                    /*#__PURE__*/ _jsxs(Select, {
                        value: companyRoleType,
                        onValueChange: handleRoleChange,
                        children: [
                            /*#__PURE__*/ _jsx(SelectTrigger, {
                                id: "companyRoleType",
                                className: "bg-background",
                                children: /*#__PURE__*/ _jsx(SelectValue, {
                                    placeholder: "Select role…"
                                })
                            }),
                            /*#__PURE__*/ _jsx(SelectContent, {
                                children: COMPANY_ROLE_TYPE_OPTIONS.map((opt)=>/*#__PURE__*/ _jsx(SelectItem, {
                                        value: opt.value,
                                        children: opt.label
                                    }, opt.value))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "space-y-1.5",
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        htmlFor: "primeContractorCompanyId",
                        children: "Prime contractor"
                    }),
                    /*#__PURE__*/ _jsxs(Select, {
                        value: primeContractorCompanyId,
                        onValueChange: onPrimeContractorCompanyIdChange,
                        children: [
                            /*#__PURE__*/ _jsx(SelectTrigger, {
                                id: "primeContractorCompanyId",
                                className: "bg-background",
                                children: /*#__PURE__*/ _jsx(SelectValue, {
                                    placeholder: companies.isLoading ? 'Loading…' : 'Select company…'
                                })
                            }),
                            /*#__PURE__*/ _jsx(SelectContent, {
                                children: (companies.data ?? []).map((c)=>/*#__PURE__*/ _jsx(SelectItem, {
                                        value: c.id,
                                        children: c.name
                                    }, c.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-xs text-muted-foreground",
                        children: "Companies come from Delivery → Registries. Add one there if the list is empty."
                    })
                ]
            })
        ]
    });
}
